import axios from 'axios'
import { BASE_FIREBASE_FUNCTIONS_URL } from '../config/config'

/**
 * Clear session cookie for universal logout
 * Call this during logout to ensure user is logged out across
 * all Loop platforms (app, docs, admin)
 *
 * @returns Response indicating success/failure
 */
export const clearSessionCookie = async () => {
  try {
    const res = await axios.post(
      `${BASE_FIREBASE_FUNCTIONS_URL}/authSignout`,
      {},
      { withCredentials: true }
    )
    return res.data
  } catch (err: any) {
    // Don't throw - logout should succeed even if clearing cookie fails
    // Cookie will expire naturally (14 days max-age)
    console.warn('Failed to clear session cookie (non-critical):', err)
    return { success: false, error: err.message }
  }
}
